import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'business-issue-field-statistics.tooltip',
		defaultMessage: 'View as chart',
		description:
			'Explains to the user that on click the issue field statistics will be displayed as a chart',
	},
});
